module.exports = __webpack_public_path__ + "img/favourite-active.86b04e4.svg";